import React from "react";
import ReactDOM from "react-dom/client";

// Import image correctly (if using local assets)


const FranchisePartners = () => {
    const images = window.FRANCHISE_IMAGES || [];

    return (
        <img
            src={images[0]} // ✅ Correct way to use imported image
            alt="flexbag down arrow"
            className="mx-auto w-full max-h-[3vh] object-contain" // ✅ Correct attribute in JSX
        />
    );
};

// ✅ Render React Component in Liquid File
const rootEl = document.getElementById("react-franchise-partner");
if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<FranchisePartners />);
}
